<template>
  <v-form>
    <v-container fluid class="ma-0 pa-0">
      <div id="left_column" class="yellow_background">
        <span class="helper"></span>
        <h1 class="app_title lotto_red robotoMediumFont">LTS Lotto Test Server</h1>
      </div>
      <div id="right_column">
        <v-layout column justify-center align-center fill-height>
          <v-card class="align-center justify-center" elevation="0">
            <v-card-text id="login_hint" class="robotoMediumFont">Login zur Verwaltung des Lotto Test Servers
            </v-card-text>
            <div style="width: 65%; margin: 0 auto;" class="align-center justify-center">
              <v-form
              ref="loginForm"
              v-model="loginForm"
              @submit.prevent="this.loginUser">
                <v-text-field
                    class="mt-lg-7"
                    v-model="email"
                    label="Benutzername"
                    required
                    outlined
                >
                  <template v-slot:prepend>
                    <img src="@/assets/ic_user_red.png" alt="username"/>

                  </template>
                </v-text-field>
                <v-text-field
                    v-model="password"
                    :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="passwordRules"
                    :type="showPass ? 'text' : 'password'"
                    name="input-10-1"
                    label="Passwort"
                    required
                    @click:append="showPass = !showPass"
                    prepend-icon="mdi-key"
                    outlined
                >
                  <template v-slot:prepend>

                    <img src="@/assets/ic_key_red.png" alt="password"/>

                  </template>
                </v-text-field>

                <v-btn
                    color="#D22321"
                    v-on:click="loginUser"
                    type="submit"
                    dark>

                  Einloggen
                </v-btn>
              </v-form>
            </div>
          </v-card>
        </v-layout>
      </div>
    </v-container>
  </v-form>
</template>
<!-- TODO change lang to ts instead js to enable typescript-->
<script lang="js">
import api from '../api/users'
import sessionStore from "@/stores/AuthStore";
import ErrorStore from "@/stores/ErrorStore.js";

export default {
  name: "login",
  data: () => {
    return {
      passwordRules: [
        v => !!v || 'Passwort ist erforderlich'
      ],
      email: '',
      password: '',
      showPass: false,
      loginForm: true
    }
  },
  methods: {
    loginUser() {
      api.login({
        email: this.email,
        password: this.password
      }).then(r => {
        sessionStore.commit('login', r)
        this.$router.push('/')
        this.email = ''
        this.password = ''
      }).catch((err) => {
        if (err.response && err.response.data) {
          ErrorStore.showError(err.response.data)
        }
      })
    }
  }
}
</script>

<style scoped>
body {
  height: 100%;
  padding: 0;
  margin: 0;
}

#left_column {
  width: 50%;
  position: absolute;
  top: 0;
  bottom: 0;
  text-align: center;
  min-width: 450px;
}

.helper {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

#right_column {
  width: 50%;
  position: absolute;
  text-align: center;
  right: 0;
  top: 0;
  bottom: 0;
}

#content {
  display: inline-block;
  vertical-align: middle;
}

.login_row {
  margin: 30px 0;
}

html {
  min-height: 100%; /* make sure it is at least as tall as the viewport */
  position: relative;
  padding: 0;
  margin: 0;
}

.yellow_background {
  background-color: #ffdf00;
}

.app_title {
  display: inline-block;
  vertical-align: middle;
  font-size: 60px;
}

#login_hint {
  color: #D22321;
  font-size: 22px;
}

</style>